<template>
  <div>
    <a-spin :spinning="isLoading">
      <div class="flex">
        <h2 class="ml-10 text-2xl">
          Edit Pricing
        </h2>
      </div>
      <div class="grid grid-cols-6 gap-8">
        <div class="col-span-4">
          <Form v-model="form" />
        </div>

        <div class="col-span-5 flex justify-evenly pb-4">
          <router-link to="/pricing">
            <a-button>Cancel</a-button>
          </router-link>
          <a-button type="primary" @click="onSubmit">
            Save
          </a-button>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import Form from "@/components/Form/pricing.vue";

export default {
  components: { Form },
  async mounted() {
    const data = await this.$store.dispatch(
      "GET_MEMBERSHIPS_BY_ID",
      this.$route.params.id
    );
    this.form = { ...this.form, ...data.data };
  },
  setup() {
    return {};
  },
  data() {
    return {
      isLoading: false,

      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
      form: {
        name: "",
        period: "",
        price: "",
        discounted_price: "",
        use_discount: "",
        features: "",
        extras: "",
        paddle_plan_id: "",
      },
    };
  },
  methods: {
    async onSubmit() {
      const { success } = await this.updatePricing();
      if (success) {
        this.$router.push("/pricing");
      }
    },
    async updatePricing() {
      this.isLoading = true;
      const pricing = await this.$store.dispatch(
        "UPDATE_MEMBERSHIP",
        this.form
      );

      this.isLoading = false;
      return pricing;
    },
  },
};
</script>

<style scoped>
.advertisements__new__actions button ~ button,
.advertisements__new__actions a ~ a,
.advertisements__new__actions a ~ button,
.advertisements__new__actions button ~ a {
  margin-left: 10px;
}
.custom_select--group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 10px;
}
</style>
